// SetProfileGuard.tsx
import { Navigate, useLocation } from "react-router-dom";

const SetProfileGuard = ({ children }) => {
    const location = useLocation();

    // If the user came from login/signup OR clicked edit profile, allow
    const allowedFrom = ["login", "signup", "edit"]; // whitelist
    const from = location.state?.from;

    if (allowedFrom.includes(from)) {
        return <>{children}</>;
    }

    // Otherwise block direct access
    return <Navigate to="/profile" replace />;
};

export default SetProfileGuard;
